import { Button, darken, lighten } from "@mui/material";
import React from "react";
import { ColorPalette } from "../../utils/constants";

type Props = {
  onClick: () => Promise<void>;
  buttonPhrase: string;
  isPressed: boolean;
  isDisabled?: boolean;
};

export const OverrideButton = ({
  onClick,
  buttonPhrase,
  isPressed,
  isDisabled = false,
}: Props) => {
  const lightRed = lighten(ColorPalette.red, 0.2);
  const darkRed = darken(ColorPalette.red, 0.5);

  return (
    <Button
      variant="contained"
      sx={{
        background: isPressed ? darkRed : lightRed,
        "&:hover": { backgroundColor: isPressed ? lightRed : darkRed },
      }}
      onClick={onClick}
      disabled={isDisabled}
    >
      {buttonPhrase}
    </Button>
  );
};
